import { render } from "./MaterialSettings.vue?vue&type=template&id=f9294c0a&scoped=true"
import script from "./MaterialSettings.vue?vue&type=script&lang=js"
export * from "./MaterialSettings.vue?vue&type=script&lang=js"

import "./MaterialSettings.vue?vue&type=style&index=0&id=f9294c0a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9294c0a"]])

export default __exports__